import axios from 'axios';

// const API_URL = 'https://medstore.debolx.com';
const API_URL = 'https://bushmusi.pythonanywhere.com';
// const API_URL = 'http://localhost:8000';

export default API_URL;

const headers = {
  'content-type': 'application/json',
};

export async function getHomePageData() {
  try {
    const res = await axios.get(`${API_URL}`, { headers });
    const { data: result, status, statusText } = res;
    return { data: result.data, status, statusText };
  } catch (error) {
    console.log('error');
    return error;
  }
}
